(function () {
	'use strict';

	angular.module('app.core')
		.service('pageTimingService', pageTimingService);

	pageTimingService.$inject = [];
	function pageTimingService() {
		var loadStartTimeMap = {};
		var initialPageLoad = true;
		var widgetLoadingMap = {
			column0: [],
			column1: [],
			column2: []
		};
		return {
			setLoadStartTime: setLoadStartTime,
			clearAllStartTimes: clearAllStartTimes,
			submitUserTiming: submitUserTiming,
			setWidgetLoadingMap: setWidgetLoadingMap,
			markWidgetDoneLoading: markWidgetDoneLoading
		};

		function setLoadStartTime(page, incomingTime, doTiming) {
			if (incomingTime) {
				initialPageLoad = true;
			} else {
				initialPageLoad = false;
			}
			if (doTiming && page) {
				loadStartTimeMap[page] = incomingTime ? incomingTime : new Date();
			}
		}

		function clearAllStartTimes() {
			var now = new Date();
			for (var key in loadStartTimeMap) {
				if (loadStartTimeMap[key]) {
					submitUserTiming(key, true);
				}
			}
		}

		function submitUserTiming(page, isCancel) {
			var pageLoadStopTime = new Date();
			// Only send user timings for Production.  We are limited by google analytics
			// on the number of timings it will process, so don't waste on dev and staging
			// if (loadStartTimeMap[page]) {
			if (loadStartTimeMap[page] && window.globalConfig) {
				var pageLoadTime = pageLoadStopTime.getTime() - loadStartTimeMap[page].getTime();
				loadStartTimeMap[page] = undefined;
				var varString = isCancel ? 'Cancelled ' : '';
				varString += (initialPageLoad ? 'Initial Load' : 'Inner Navigation');
				var timingLabel;
				if (pageLoadTime > 60000) {
					pageLoadTime = 60000;
					timingLabel = 'Exceeded 1 Minute';
				} else {
					timingLabel = 'Normal';
				}
			}
			initialPageLoad = false;
		}

		function setWidgetLoadingMap(wlm) {
			widgetLoadingMap = wlm;
		}

		function markWidgetDoneLoading(column, position) {
			widgetLoadingMap[column][position] = false;
			if (!checkIfAnyWidgetsLoading()) {
				submitUserTiming('Dashboard');
			}
		}

		function checkIfAnyWidgetsLoading() {
			var column0Creating = widgetLoadingMap.column0.reduce(function(sum, next) {
				return sum || next;
			}, false);
			var column1Creating = widgetLoadingMap.column1.reduce(function(sum, next) {
				return sum || next;
			}, false);
			var column2Creating = widgetLoadingMap.column2.reduce(function(sum, next) {
				return sum || next;
			}, false);
			return column0Creating || column1Creating || column2Creating;
		}
	}
})();
